import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Order.css";
import logo from "../COMPONENTS/IMAGES/Frame 197.png";
import axios from "axios";
import { API_BASE, FILE_BASE } from "../config";

const Orders = () => {
  const [activeTab, setActiveTab] = useState("orders");
  const [showLogout, setShowLogout] = useState(false);

  const [customerData, setCustomerData] = useState(null);
  const [orders, setOrders] = useState([]);

  const navigate = useNavigate();


  useEffect(() => {
    fetchCustomerData();
  }, []);

  const fetchCustomerData = async () => {
    try {
      const customerString =
        sessionStorage.getItem("customer");

      if (!customerString) {
        console.log("No customer found");

        navigate("/");
        return;
      }

      const customer = JSON.parse(customerString);

      if (!customer || !customer.id) {
        console.log("Invalid customer");

        navigate("/");
        return;
      }

      const response = await axios.get(
        `${API_BASE}/customer/${customer.id}`
      );

      setCustomerData(response.data);
      setOrders(response.data.orders || []);

    } catch (error) {
      console.log(error);
    }
  };

  const handleLogout = async () => {
    try {

      // OPTIONAL API CALL
      await axios.post(`${API_BASE}/auth/logout`);

    } catch (error) {

      console.log(error);

    } finally {

      // ALWAYS CLEAR STORAGE
      sessionStorage.clear();
      localStorage.clear();

      // REDIRECT
      navigate("/", { replace: true });

    }
  };

  const handleBack = () => {
    navigate("/");
  };

  return (
    <div className="orders-container">

      {/* HEADER */}
      <header className="sapa-header-container">

        <div className="sapa-header-left">

          <span
            onClick={() => setActiveTab("orders")}
            className={`sapa-header-link ${activeTab === "orders"
                ? "active-link"
                : ""
              }`}
          >
            Orders
          </span>

          <span
            onClick={() => setActiveTab("profile")}
            className={`sapa-header-link ${activeTab === "profile"
                ? "active-link"
                : ""
              }`}
          >
            Profile
          </span>

        </div>

        <div className="pink-logo">
          <img
            src={logo}
            alt="SaPra Logo"
          />
        </div>

        <div className="sapa-header-right">

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
          >
            <path
              d="M14.0001 14C12.7167 14 11.6181 13.543 10.7042 12.6291C9.79036 11.7152 9.33341 10.6166 9.33341 9.33329C9.33341 8.04996 9.79036 6.95135 10.7042 6.03746C11.6181 5.12357 12.7167 4.66663 14.0001 4.66663C15.2834 4.66663 16.382 5.12357 17.2959 6.03746C18.2098 6.95135 18.6667 8.04996 18.6667 9.33329C18.6667 10.6166 18.2098 11.7152 17.2959 12.6291C16.382 13.543 15.2834 14 14.0001 14Z"
              fill="black"
            />
          </svg>

        </div>

      </header>

      {/* ORDERS TAB */}
      {activeTab === "orders" && (
        <div className="order-section">

          <h2>Orders</h2>

          {orders.length > 0 ? (
            orders.map((order, index) => (
              <div
                className="order-card"
                key={index}
              >

                <div className="order-top">

                  <span
                    className={`status ${order.status === "Delivered"
                        ? "delivered"
                        : "progress"
                      }`}
                  >
                    ● {order.status}
                  </span>

                  <span className="datee">
                    {new Date(
                      order.orderDate
                    ).toLocaleDateString(
                      "en-IN",
                      {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                      }
                    )}
                  </span>

                </div>

                <div className="order-content">

                  <div className="order-details">

                    <h4>
                      Order No.{" "}
                      {order.orderNumber}
                    </h4>

                    <p>Total Amount</p>

                    <span className="price">
                      ₹ {order.totalAmount}
                    </span>

                  </div>

                  <div className="arroww">
                    ›
                  </div>

                </div>

              </div>
            ))
          ) : (
            <p>No Orders Found</p>
          )}

        </div>
      )}

      {/* PROFILE TAB */}
      {activeTab === "profile" &&
        customerData && (
          <div className="order-section">

            <h2>Profile</h2>

            {/* NAME */}
            <div className="profile-card">

              <div className="profile-row">
                <span className="profile-label">
                  Name
                </span>
              </div>

              <p className="profile-value">
                {customerData.name || "-"}
              </p>

            </div>

            {/* MOBILE */}
            <div className="profile-card">

              <div className="profile-row">
                <span className="profile-label">
                  Mobile Number
                </span>
              </div>

              <p className="profile-value">
                {customerData.phoneNumber || "-"}
              </p>

            </div>

            {/* EMAIL */}
            <div className="profile-card">

              <div className="profile-row">
                <span className="profile-label">
                  Email
                </span>
              </div>

              <p className="profile-value">
                {customerData.email || "-"}
              </p>

            </div>

            {/* ADDRESS */}
            <div className="profile-card">

              <div className="profile-row">
                <span className="profile-label">
                  Address
                </span>
              </div>

              <p className="profile-value">
                {customerData.address || "-"}
              </p>

              <p className="profile-value">
                {customerData.city || ""}{" "}
                {customerData.state || ""}{" "}
                {customerData.pincode || ""}
              </p>

            </div>

            {/* TOTAL ORDERS */}
            <div className="profile-card">

              <div className="profile-row">
                <span className="profile-label">
                  Total Orders
                </span>
              </div>

              <p className="profile-value">
                {customerData.totalOrders}
              </p>

            </div>

            {/* TOTAL SPENT */}
            <div className="profile-card">

              <div className="profile-row">
                <span className="profile-label">
                  Total Spent
                </span>
              </div>

              <p className="profile-value">
                ₹ {customerData.totalSpent}
              </p>

            </div>

          </div>
        )}

      {/* BUTTONS - VISIBLE ON BOTH TABS */}
      <div className="profile-btn">

        <button
          className="logout-btn"
          onClick={() => setShowLogout(true)}
        >
          Logout
        </button>

        <button
          className="logout-btn"
          onClick={handleBack}
        >
          Back
        </button>

      </div>

      {/* LOGOUT POPUP */}
      {showLogout && (
        <div className="popup-overlay">

          <div className="popup-box">

            <h3>
              Are you sure you want to logout?
            </h3>

            <div className="popup-actions">

              <button
                className="cancel-btn"
                onClick={() =>
                  setShowLogout(false)
                }
              >
                Cancel
              </button>

              <button
                className="confirm-btn"
                onClick={handleLogout}
              >
                Logout
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default Orders;